import dayjs from "dayjs";
import { fmtDate } from "@/lib/format";

export const leaveOn = (org) => (org?.module_access || {}).leave === true;
export const clockOn = (org) => (org?.module_access || {}).clocking === true;

const trim = (n) => String(Number(Number(n || 0).toFixed(2)));
export const fmtH = (h) => `${trim(h)}h`;
// Balances are held in hours; days use the person's average working day.
export const fmtDays = (h, day) => {
  if (!day) return fmtH(h);
  const d = Number(((h || 0) / day).toFixed(2));
  return `${trim(d)} day${Math.abs(d) === 1 ? "" : "s"}`;
};
export const fmtDur = (min) => `${Math.floor((min || 0) / 60)}h ${String((min || 0) % 60).padStart(2, "0")}m`;
export const fmtTime = (iso, tz) => (iso ? new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz }) : "—");
export const localHHMM = (iso, tz) => (iso ? fmtTime(iso, tz) : "");

export const LEAVE_STATUS = {
  pending: { label: "Awaiting approval", rag: "amber" },
  approved: { label: "Approved", rag: "green" },
  rejected: { label: "Not approved", rag: "red" },
  withdrawn: { label: "Withdrawn", rag: "grey" },
  cancelled: { label: "Cancelled", rag: "grey" },
};
export const CORRECTION_STATUS = {
  pending: { label: "Awaiting approval", rag: "amber" },
  approved: { label: "Applied", rag: "green" },
  rejected: { label: "Not approved", rag: "red" },
  withdrawn: { label: "Withdrawn", rag: "grey" },
};
export const PART_LABEL = { full: "Full day", am: "Morning", pm: "Afternoon", hours: "Hours" };

export const CELL = {
  in: { label: "In", cls: "bg-[#3D8B65]/10 text-[#3D8B65]" },
  off: { label: "Off", cls: "text-white" },
  part: { label: "Part day", cls: "text-white" },
  holiday: { label: "Public holiday", cls: "bg-[#FFB000]/20 text-[#8A5C00]" },
  non_working: { label: "Not working", cls: "bg-[#EEF1F6] text-[#1E2D44]/30" },
  unknown: { label: "No work pattern", cls: "bg-white text-[#1E2D44]/25" },
};

export const requestWhen = (r) => {
  if (r.start_date !== r.end_date) return `${fmtDate(r.start_date)} – ${fmtDate(r.end_date)}`;
  const part = r.part === "hours" ? ` · ${fmtH(r.hours)}` : r.part !== "full" ? ` · ${PART_LABEL[r.part]}` : "";
  return `${dayjs(r.start_date).format("ddd DD/MM/YYYY")}${part}`;
};
export const requestSize = (r) => (r.part === "full" ? `${r.days.length} working day${r.days.length === 1 ? "" : "s"} · ${fmtH(r.hours)}` : fmtH(r.hours));

export const TIMEZONES = ["Europe/Dublin", "Europe/London", "Europe/Lisbon", "Europe/Paris", "Europe/Berlin", "Europe/Madrid", "Europe/Warsaw",
  "America/New_York", "America/Chicago", "America/Los_Angeles", "Asia/Dubai", "Asia/Singapore", "Australia/Sydney", "UTC"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
